import script from "./PaymentSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentSettings.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentSettings.vue?vue&type=style&index=0&id=12057af2&lang=scss&scoped=true"
import "./PaymentSettings.vue?vue&type=style&index=1&id=12057af2&lang=scss"
script.__scopeId = "data-v-12057af2"

export default script